import 'slick-slider';
import {WPApi} from "../common/wp-api";
// import * as pageGlobals from "../common/globals";
import "../common/jquery-functions";

const wp = new WPApi();

const analyticsCategory = 'reporter-page';

jQuery(document).ready(async ($) => {
    let pageNumber = 1;
    const $twitterContainer = $('.twitter-posts');
    if ($twitterContainer.length) {
        // $twitterContainer.loader(true);
        let urlRequest = 'sport1/v1/social/author/' + pageGlobals.object_id + '/tweets';
        try {

            let tweetsSliderItems = await wp.get(urlRequest);
            if (tweetsSliderItems !== '') {
                $twitterContainer.append(tweetsSliderItems);
                let $gallery = $('.tweets-slider');
                if ($gallery.length) {
                    $gallery.slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        autoplay: false,
                        autoplaySpeed: 7000,
                        rtl: true,
                        lazyLoad: 'onDemand',
                        prevArrow: '<img class="prev" />',
                        nextArrow: '<img class="next" />',
                        dots: true,
                    });
                }
            }
        } catch (e) {

        } finally {
            // $twitterContainer.loader(false);
        }

    }


    // Load more posts on scroll in mobile
    /*if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) )  {
        $(window).scroll(async function() {
            if($(window).scrollTop() == $(document).height() - $(window).height()) {
                if(pageGlobals.max_num_pages > pageNumber) {
                    pageNumber++;
                    let urlMorePostsRequest = 'sport1/v1/social/author/'+ pageGlobals.object_id +'/more_posts/'+ pageNumber;
                    let morePosts = await wp.get(urlMorePostsRequest);
                    if (morePosts) {
                        $('.posts-container').append(morePosts);
                        if (pageNumber > 2) {
                            window.history.replaceState('', '', pageNumber);
                        } else {
                            window.history.replaceState('', '', 'page/' + pageNumber);
                        }
                    }
                }
            }
        });
    }*/

    $('.load-more-posts').click(async function () {

        sport1Analytics.sendEvent(analyticsCategory, 'click', 'more article reload');

        pageNumber++;
        let urlMorePostsRequest = 'sport1/v1/social/author/' + pageGlobals.object_id + '/more_posts/' + pageNumber;
        let morePosts = await wp.get(urlMorePostsRequest);
        if (morePosts) {
            $('.posts-container').append(morePosts);
            if (pageNumber > 2) {
                window.history.replaceState('', '', pageNumber);
            } else {
                window.history.replaceState('', '', 'page/' + pageNumber);
            }
        }
        if (pageGlobals.max_num_pages <= pageNumber) {
            $('.load-more-posts').remove();
        }
    });

    $(document).on('click', '.post-card', function () {
        const label = $('h3', this).text().trim();
        sport1Analytics.sendEvent(analyticsCategory, 'reporter-article-click', label);
    })
});
